import { render, staticRenderFns } from "./SelectFromWorkRecords.html?vue&type=template&id=977c3cc0&scoped=true&external"
import script from "./SelectFromWorkRecords.ts?vue&type=script&lang=ts&external"
export * from "./SelectFromWorkRecords.ts?vue&type=script&lang=ts&external"
import style0 from "./SelectFromWorkRecords.css?vue&type=style&index=0&id=977c3cc0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977c3cc0",
  null
  
)

export default component.exports